import Login from './Login'
import '../../../../utils/i18n'

export default Login
